export enum ChatVisibility {
    Internal_External = 2,
    Internal = 1,
    Offline = 0
}